var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-content" },
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.loadingColor },
      }),
      _vm._v(" "),
      !_vm.loading
        ? _c("div", [
            _c("div", { staticClass: "card" }, [
              _c("div", { staticClass: "card-body" }, [
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Обновить список запросов",
                        type: "button",
                        loading: _vm.btnLoading,
                        color: _vm.$constants.SUCCESS_COLOR,
                        onClick: _vm.getRequests,
                        className: "btn btn-outline-success br-0",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c("LoadingButton", {
                      attrs: {
                        title: "Новый запрос",
                        type: "button",
                        loading: _vm.btnLoading,
                        color: _vm.$constants.LOADING_COLOR,
                        onClick: _vm.newRequest,
                        className: "btn btn-outline-info br-0",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex" },
                  [
                    _vm.dialogs && _vm.dialogs.length
                      ? [
                          _c(
                            "div",
                            { staticClass: "w-100p chat_list" },
                            [
                              _c("ChatList", {
                                attrs: {
                                  dialogs: _vm.dialogs,
                                  displayDetails: { orderId: true },
                                  onSelect: _vm.onSelectDialog,
                                  selectedDialogId: _vm.selectedDialog.id,
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "messages_block" },
                            [
                              _vm.selectedDialog &&
                              _vm.selectedDialog.id &&
                              _vm.activeMessages
                                ? [
                                    _c("Messages", {
                                      attrs: {
                                        hideNames: true,
                                        dialogId: _vm.selectedDialog.id,
                                        dialogAccepted:
                                          +_vm.selectedDialog.user_id ===
                                            _vm.$currentUID ||
                                          !!_vm.selectedDialog.is_accepted,
                                        messages: _vm.activeMessages,
                                        updateDialog: () =>
                                          _vm.getRequests(true),
                                      },
                                    }),
                                  ]
                                : [
                                    _c("h5", { staticClass: "p-2" }, [
                                      _vm._v("Выберите диалог"),
                                    ]),
                                  ],
                              _vm._v(" "),
                              _vm.selectedDialog &&
                              _vm.selectedDialog.id &&
                              +_vm.selectedDialog.user_id === _vm.$currentUID
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "text-right" },
                                      [
                                        _c("LoadingButton", {
                                          attrs: {
                                            title:
                                              "Вопрос решен, закрыть запрос",
                                            type: "button",
                                            loading: _vm.btnLoading,
                                            color: _vm.$constants.SUCCESS_COLOR,
                                            onClick: _vm.closeDialog,
                                            className:
                                              "btn btn-outline-success",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                            2
                          ),
                        ]
                      : [_vm._m(0)],
                  ],
                  2
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("h4", [_vm._v("Нет активных диалогов")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }